module.exports = __webpack_public_path__ + "media/theme/icon__address-c3b2ad7a.png";